import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmType } from '../interfaces/IKnmType';

export async function knmTypesCancelled(): Promise<IKnmType[]> {
  return apiGet<IKnmType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/abrogation-reasons`);
}
